export const TEST_ID = 'userDetailsEditCard';
